import { useFragment } from "@apollo/client";

import {
  AssessmentFragment,
  AssessmentFragmentDoc,
  AssessmentSettingsFragment,
  AssessmentSettingsFragmentDoc,
} from "@/generated/graphql";

export function useAssessmentSettingsFragment(assessmentId: string) {
  const { data, complete } = useFragment<AssessmentSettingsFragment>({
    from: {
      id: assessmentId,
      __typename: "AssessmentSettings",
    },
    fragment: AssessmentSettingsFragmentDoc,
    fragmentName: "AssessmentSettings",
  });

  if (!data || !complete) return null;
  return data;
}

export function useAssessmentFragment(assessmentId: string) {
  const { data } = useFragment<AssessmentFragment>({
    fragment: AssessmentFragmentDoc,
    fragmentName: "Assessment",
    from: {
      __typename: "Assessment",
      id: assessmentId,
    },
  });

  return data;
}
